export default __webpack_public_path__ + "static/media/Shavin.db008120.png";